import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  span {
    font-size: 0.6rem;
    font-weight: 500;
    text-transform: uppercase;
  }
`;
